<template>
  <span
    class="material-symbols-rounded app-icon"
    :class="[utilityClasses, { 'app-icon--filled': filled }]"
    :style="iconStyle"
    :aria-hidden="label ? null : 'true'"
    :aria-label="label || null"
    :role="label ? 'img' : null"
    v-bind="$attrs"
    v-on="$listeners"
  >{{ resolvedName }}</span>
</template>

<script>
import {
  getIconUtilityClasses,
  resolveAppIcon,
} from './iconRegistry'

const BASE_ICON_SCALE = 1.1

export default {
  name: 'AppIcon',
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    fontScale: {
      type: [Number, String],
      default: 1,
    },
    fill: {
      type: [Boolean, Number, String],
      default: null,
    },
    weight: {
      type: [Number, String],
      default: 400,
    },
    opticalSize: {
      type: [Number, String],
      default: 24,
    },
    inheritSize: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    source() {
      return this.name || this.icon
    },
    resolvedName() {
      return resolveAppIcon(this.source)
    },
    utilityClasses() {
      return getIconUtilityClasses(this.source)
    },
    filled() {
      if(this.fill !== null) {
        return this.fill === true || this.fill === 1 || this.fill === '1' || this.fill === 'true'
      }
      return /(?:-fill|-filled| fa-circle)(?:\s|$)/.test(this.source)
    },
    iconStyle() {
      const scale = Number(this.fontScale) || 1
      const weight = Number(this.weight) || 400
      const opticalSize = Number(this.opticalSize) || 24

      return {
        fontSize: this.inheritSize ? null : (BASE_ICON_SCALE * scale) + 'em',
        fontVariationSettings: `'FILL' ${this.filled ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' ${opticalSize}`,
      }
    },
  },
}
</script>

<style>
/* El nombre del ícono también queda como clase: "close" activaría el .close de Bootstrap. */
.app-icon.close {
  float: none;
  color: inherit;
  font-weight: inherit;
  text-shadow: none;
  opacity: 1;
}

.app-icon {
  /* Las utilidades tipográficas de Bootstrap (p. ej. .h5) también asignan
     font-family. El ícono debe conservar siempre su fuente de ligaduras. */
  font-family: 'Material Symbols Rounded' !important;
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
  overflow: hidden;
  font-size: 1em;
  line-height: 1;
  text-transform: none;
  vertical-align: -0.125em;
  color: inherit;
}
</style>
